import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

export const noProductsWithTypesInScene = (productTypes: ProductType[]) => (coreApi: CoreApi) => {
  const entitesInSceneOfType = coreApi.entities.getByProductTypes(productTypes);
  return entitesInSceneOfType.length === 0;
};

export const noProductsWithComponentsInScene = (componentIds: number[]) => (coreApi: CoreApi) => {
  const entitesInSceneWithComponents = coreApi.entities.getByComponents(componentIds);
  return entitesInSceneWithComponents.length === 0;
};

export const noProductsWithTypesForSelectedEntity = (
  productTypes: ProductType[],
  onlyDirectChildren?: boolean
) => (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return false;

  const entitiesOfType = onlyDirectChildren
    ? coreApi.entities.getChildrenWithOneOfProductTypes(selectedEntity, productTypes)
    : coreApi.entities.getDescendantsWithOneOfProductTypes(selectedEntity, productTypes);

  return entitiesOfType.length === 0;
};
